import React from "react";
import CryptoJS from "crypto-js";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import defaultImage from "assets/img/default-avatar.png";

const style = {
  details: {
    textAlign: "center"
  },
  picture: {
    margin: "5px auto 20px auto",
    display: "block"
  },
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  inputAdornment: {
    position: "relative"
  }
};

class MyProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imagePreviewUrl: defaultImage,
      firstname: JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('given_name'),'secretpass').toString(CryptoJS.enc.Utf8)),
      lastname: JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('family_name'),'secretpass').toString(CryptoJS.enc.Utf8)),
      email: JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('email'),'secretpass').toString(CryptoJS.enc.Utf8))
    };
  }
  //   sendState() {
  //     return this.state;
  //   }
  // function that returns true if value is email, false otherwise
  //   verifyEmail(value) {
  //     var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //     if (emailRex.test(value)) {
  //       return true;
  //     }
  //     return false;
  //   }
  // function that verifies if a string has a given length or not
  //   verifyLength(value, length) {
  //     if (value.length >= length) {
  //       return true;
  //     }
  //     return false;
  //   }
  //   change(event, stateName, type, stateNameEqualTo) {
  //     switch (type) {
  //       case "email":
  //         if (this.verifyEmail(event.target.value)) {
  //           this.setState({ [stateName + "State"]: "success" });
  //         } else {
  //           this.setState({ [stateName + "State"]: "error" });
  //         }
  //         break;
  //       case "length":
  //         if (this.verifyLength(event.target.value, stateNameEqualTo)) {
  //           this.setState({ [stateName + "State"]: "success" });
  //         } else {
  //           this.setState({ [stateName + "State"]: "error" });
  //         }
  //         break;
  //       default:
  //         break;
  //     }
  //     this.setState({ [stateName]: event.target.value });
  //   }
  //   isValidated() {
  //     if (
  //       this.state.firstnameState === "success" &&
  //       this.state.lastnameState === "success" &&
  //       this.state.emailState === "success"
  //     ) {
  //       return true;
  //     } else {
  //       if (this.state.firstnameState !== "success") {
  //         this.setState({ firstnameState: "error" });
  //       }
  //       if (this.state.lastnameState !== "success") {
  //         this.setState({ lastnameState: "error" });
  //       }
  //       if (this.state.emailState !== "success") {
  //         this.setState({ emailState: "error" });
  //       }
  //     }
  //     return false;
  //   }
  render() {
    const { classes } = this.props;
    return (
      <GridContainer justify="center">
        <GridItem xs={12}>
          {/* <div className={classes.picture}>
            <div className="picture-container">
              <div className="picture">
                <img
                  src={this.state.imagePreviewUrl}
                  className="picture-src"
                  alt="..."
                />
              </div>
            </div>
          </div> */}
          <div className={classes.details}>
            <h4>
              First Name : <b> &nbsp; {this.state.firstname}</b>{" "}
            </h4>
            <h4>
              Last Name : <b> &nbsp; {this.state.lastname}</b>{" "}
            </h4>
            <h4>
              Email : <b> &nbsp; {this.state.email}</b>{" "}
            </h4>
          </div>
        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(style)(MyProfile);



// WEBPACK FOOTER //
// ./src/views/User/MyProfile.jsx